import React, { useState, useEffect } from "react";
import styled from "styled-components";

const QuizPublicLink = styled.div`
  position: relative;
`;

const QuizContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  z-index:2;
  gap: 10px;
`;

const QuizActionButton = styled.button`
  padding: 10px 15px;
  cursor: pointer;
  background-color: white;
  border: 1px solid grey;
  border-radius: 4px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const PublicLink = ({ quiz_name, type, quiz_item_id }) => {
  const [url, setUrl] = useState("");
  const [iframeCode, setIframeCode] = useState("");
  const [urlCopied, setUrlCopied] = useState(false);
  const [iframeCopied, setIframeCopied] = useState(false);

  useEffect(() => {
    const gameUrl = window.location.href.includes("localhost")
      ? "http://localhost:8000/"
      : "https://tools.vrtinnovatie.be/EDUbox/games/";

    const getQuizNameParam = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get("quiz");
    };

    const currentUrl = `${gameUrl}quiz-game/?quiz=${getQuizNameParam()}&${type}=${quiz_item_id}`;
    setUrl(currentUrl);
    setIframeCode(
      `<iframe src="${currentUrl}&scale=1&iframereset=true" width="500" height="600" style="border: none;" scrolling="no"></iframe>`
    );
  }, [quiz_item_id, type]);

  const copyToClipboard = (text, setCopied) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(
        () => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500); // Reset copied state after 1.5 seconds
        },
        (err) => {
          console.error('Could not copy text: ', err);
        }
      );
    } else {
      // Fallback for older browsers (including iOS Safari)
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // Reset copied state after 1.5 seconds
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <QuizPublicLink>
      <QuizContainer>
        <QuizActionButton onClick={() => copyToClipboard(url, setUrlCopied)}>
          {urlCopied ? "URL Gekopieerd" : "Kopieer link"}
        </QuizActionButton>
        <QuizActionButton
          onClick={() => copyToClipboard(iframeCode, setIframeCopied)}
        >
          {iframeCopied ? "Iframe Gekopieerd" : "Kopieer iframe"}
        </QuizActionButton>
      </QuizContainer>
    </QuizPublicLink>
  );
};

const QuestionPublicLink = ({ overViewPage, type, quiz_item_id }) => {
  if (overViewPage) {
    return (
      <>
        <PublicLink type={type} quiz_item_id={quiz_item_id} />
      </>
    );
  } else {
    return <></>;
  }
};

export default QuestionPublicLink;
